import React, { useEffect, useRef, useState } from 'react';
import type { Entry } from '../types/raffle';
interface TileBoardProps {
  pool: Entry[];
  targetIndex: number | null;
  /** Increments to start a new run. */
  spinToken: number;
  spinSeconds: number;
  onSpinComplete: () => void;
}
const easeOutQuart = (p: number) => 1 - Math.pow(1 - p, 4);
export function TileBoard({
  pool,
  targetIndex,
  spinToken,
  spinSeconds,
  onSpinComplete
}: TileBoardProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [landed, setLanded] = useState(false);
  const tileRefs = useRef<Array<HTMLLIElement | null>>([]);
  const completeRef = useRef(onSpinComplete);
  completeRef.current = onSpinComplete;
  useEffect(() => {
    if (spinToken === 0 || targetIndex === null) return;
    const count = pool.length;
    if (count === 0) return;
    setLanded(false);
    const start = Math.floor(Math.random() * count);
    const laps = count <= 60 ? 3 : 1.4;
    const offset = ((targetIndex - start) % count + count) % count;
    const totalSteps = Math.round(laps * count) + offset;
    const duration = spinSeconds * 1000;
    const t0 = performance.now();
    let frame = 0;
    let last = -1;
    let done = false;
    const tick = (now: number) => {
      const p = Math.min(1, (now - t0) / duration);
      const index = p >= 1 ? targetIndex : Math.round(start + totalSteps * easeOutQuart(p)) % count;
      if (index !== last) {
        last = index;
        setActiveIndex(index);
        if (p > 0.7) {
          tileRefs.current[index]?.scrollIntoView({
            block: 'nearest'
          });
        }
      }
      if (p < 1) {
        frame = requestAnimationFrame(tick);
      } else {
        done = true;
        tileRefs.current[targetIndex]?.scrollIntoView({
          block: 'nearest',
          behavior: 'smooth'
        });
        setLanded(true);
        window.setTimeout(() => completeRef.current(), 260);
      }
    };
    frame = requestAnimationFrame(tick);
    return () => {
      if (!done) cancelAnimationFrame(frame);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spinToken]);
  const dense = pool.length > 80;
  return <div className="w-full" data-id="element-313" data-mp="1q4i5zl8spfyc">
      <ul className="grid max-h-[58vh] gap-1.5 overflow-y-auto rounded-xl border border-line bg-surface p-3" style={{
      gridTemplateColumns: `repeat(auto-fill, minmax(${dense ? '6.5rem' : '8.5rem'}, 1fr))`
    }} aria-label={`${pool.length} names in the draw`} data-id="element-314" data-mp="1q3qaeaf77i82">
        {pool.map((entry, i) => {
        const active = activeIndex === i;
        return <li key={entry.id} ref={el => {
          tileRefs.current[i] = el;
        }} aria-current={active ? 'true' : undefined} className={`truncate rounded-md border px-2.5 text-center font-medium transition-[background-color,border-color,color,transform] duration-100 ease-emphasis ${dense ? 'py-1.5 text-[11px]' : 'py-2.5 text-xs'} ${active ? `scale-[1.06] border-gold text-ink ${landed ? 'bg-gold' : 'bg-[#F0C154]'}` : 'border-line bg-raised text-body'}`} title={entry.name} data-id="element-315" data-mp="176p2ohu9f40f" data-mpi={i}>
              {entry.name}
            </li>;
      })}
      </ul>
    </div>;
}